import storage from "./storage";
import {dev} from "../../config";

const IP = process.env.IP;

export const betaAppPort = 5050;
export const betaAppUrl = process.env.REACT_APP_API_URL || "https://api.invisiblesport.com";

export const betaOperatorPort = 5051;
export const betaOperatorUrl = process.env.OPERATOR_API_URL || "https://operator-api.invisiblesport.com";

export const devPromoImagesUrl = "https://d1mhv939rvsge7.cloudfront.net";
export const betaPromoImagesUrl = 'https://d1q02p2aewq5vt.cloudfront.net';
export const prodPromoImagesUrl = "https://d1bvoel1nv172p.cloudfront.net";

const devEnv = {
  name: "beta",
  operatorUrl: IP ? `http://${IP}:${betaOperatorPort}` : betaOperatorUrl,
  apiUrl: IP ? `http://${IP}:${betaAppPort}` : betaAppUrl,
};

export const AVAILABLE_ENVS = [devEnv];

export const getEnv = () => {
  const savedEnv = storage.getItem("bt_env");

  // btby.bbbet.click, demo.betby.games... all demo sites for customers
  if(process.env.PRESENTATION) {
    const defaultApiUrl = process.env.BT_RENDERER_URL;

    return {
      name: null,
      operatorUrl: process.env.OPERATOR_API_URL,
      apiUrl: process.env.REACT_APP_API_URL || defaultApiUrl,
    };
  }

  // saved config dev-facade
  if(savedEnv) {
    return JSON.parse(savedEnv)
  }

  // dev-facade
  return devEnv;
};
